import { useTheme } from "@emotion/react";
import { IconButton, Tooltip, Typography } from "@mui/material"
import { UseFieldArrayReturn, UseFormReturn, Path } from "react-hook-form";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import { DocumentStructure } from "../../../../../models/document-structure";
import MuiInput from "../../../../../components/mui-input/MuiInput";
import { DocumentItemAdd } from "../../../../../models/document-item";
import { DocumentAdd, DocumentEdit } from "../../../../../models/document";
import { ItemsFormType, PaymentsFormType, WorksFormType } from "../../../document/add-document/AddDocument.types";
import { useLocation, useNavigate } from "react-router-dom";
import { DocumentSettings } from "../../../../../models/document-settings";
import { useEffect, useRef, useState } from "react";
import { fixedNumber } from "../../../../../helpers/helpers";
import { Item } from "../../../../../models/item";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ClearIcon from '@mui/icons-material/Clear';

interface DocumentItemsProps {

    method: "add" | "edit";

    // itemsForm: UseFormReturn<{ items: DocumentItemAdd[] }> | UseFormReturn<{ items: DocumentItemEdit[] }>;
    documentForm: UseFormReturn<DocumentAdd> | UseFormReturn<DocumentEdit>;
    worksForm: UseFormReturn<WorksFormType>
    itemsForm: UseFormReturn<ItemsFormType>
    paymentsForm: UseFormReturn<PaymentsFormType>

    itemsFieldArray: UseFieldArrayReturn<{ items: DocumentItemAdd[] }, "items", "id">;

    settings: DocumentSettings;
    structure: DocumentStructure[];

    calcDocument: () => void;
    isDocumentClosed?: boolean;
}


function DocumentItems({ method, documentForm, worksForm, itemsForm, paymentsForm, itemsFieldArray, settings, structure, calcDocument, isDocumentClosed }: DocumentItemsProps) {

    const navigate = useNavigate();
    const { state } = useLocation();
    const theme = useTheme();

    const [itemRowIndex, setItemRowIndex] = useState<number>(0); // item row index clicked
    const userTriggered = useRef<boolean>(true);
    // const [focusedFieldName, setFocusedFieldName] = useState<string>();


    //update item line when one field in the line changes.
    useEffect(() => {

        const subscription = itemsForm.watch((_, { name }) => {

            if (userTriggered.current === true && name?.includes("items.")) {
                updateItemRow(name);
            }
        });

        return () => subscription.unsubscribe();

    }, [itemsForm]);



    function renderItemField(field: DocumentStructure, rowIndex: number) {

        const calcFields = ["amount", "price", "discount", "net", "total"];

        if(calcFields.includes(field.field_name)){
            return <MuiInput 
                // key={field.id}
                field={field}
                variant='outlined'
                useForm={itemsForm}
                prefix={`items.${rowIndex}.`}
                showRequired
                disabled={isDocumentClosed}
            />
        }
        
        else{
            return <MuiInput 
                // key={field.id}
                field={field}
                variant='outlined'
                useForm={itemsForm}
                prefix={`items.${rowIndex}.`}
                showRequired
                disabled={isDocumentClosed}
                searchType="פריט"
                onSelect={onItemSelect}
            />
        }
    }


    function onItemSelect(item: Item){

        const updatedItems: DocumentItemAdd[] = [...itemsForm.getValues().items];

        console.log("updatedItems: ", updatedItems);

        updatedItems[itemRowIndex] = {
            ...item,
            id: undefined,
            item_id: item.id,
            amount: 1,
            price: item.price ?? 0,
            net: item.price ?? 0,
            total: item.price ?? 0
        };

        console.log("updatedItems after update: ", updatedItems);

        itemsForm.reset({
            items: updatedItems
        });
    }


    // update item row after one field changed
    function updateItemRow(name: Path<ItemsFormType>) {

        console.log("updateItemRow fieldName", name);

        userTriggered.current = false;

        const firstDotIndex = name.indexOf('.');
        const secondDotIndex = name.indexOf('.', firstDotIndex + 1);

        const rowIndex = Number(name.substring(firstDotIndex + 1, secondDotIndex));
        const fieldName = name?.slice(secondDotIndex + 1);


        const amount = itemsForm.getValues(`items.${rowIndex}.amount`) || 1;
        const price = itemsForm.getValues(`items.${rowIndex}.price`);
        const discount = itemsForm.getValues(`items.${rowIndex}.discount`);
        const net = itemsForm.getValues(`items.${rowIndex}.net`);
        const total = itemsForm.getValues(`items.${rowIndex}.total`);

        let updatedNet;
        let updatedPrice;


        switch (fieldName) {

            case 'price': case 'discount':

                updatedNet = price * (1 - ((discount || 0) / 100));

                itemsForm.setValue(`items.${rowIndex}.net`, fixedNumber(updatedNet));
                itemsForm.setValue(`items.${rowIndex}.total`, fixedNumber(updatedNet * (amount || 1)));


                break;

            case 'amount':

                updatedNet = price - (price * (discount || 0) / 100);

                itemsForm.setValue(`items.${rowIndex}.net`, fixedNumber(updatedNet));
                itemsForm.setValue(`items.${rowIndex}.total`, fixedNumber(updatedNet * (amount || 1)));

                break;


            case 'net':

                itemsForm.setValue(`items.${rowIndex}.discount`, fixedNumber((1 - ((net || 0) / price)) * 100));
                itemsForm.setValue(`items.${rowIndex}.total`, fixedNumber((net || 0) * amount));

                break;


            case 'total':

                updatedPrice = (total || 0) / ((amount || 1) * ((1 - ((discount || 0) / 100)) || 1));

                itemsForm.setValue(`items.${rowIndex}.price`, fixedNumber(updatedPrice));
                itemsForm.setValue(`items.${rowIndex}.net`, fixedNumber(updatedPrice * (1 - ((discount || 0) / 100))));

                break;

                
            default:
                break;
        }

        // itemsForm.setFocus(name);
        // setFocusedFieldName(name);
        userTriggered.current = true;
        //calc the new payment section
        calcDocument();
        
    }

    // //return the focus to the field that was changed
    // function isFocused(baseName: string, inputName: string, ): boolean {
    //     return `${baseName}${inputName}` === focusedFieldName;
    // }
    
    
    //add a new item line
    function addItemLine(): void {

        itemsFieldArray.append({
            sku: "",
            name: "",
            amount: 1,
            price: 0,
            discount: 0,
            net: 0,
            total: 0,
        });

        setItemRowIndex(itemsFieldArray.fields.length);
    }

    //deleting a row by specify an index and row type
    function deleteRow(index: number): void {

        setItemRowIndex(0);
        itemsFieldArray.remove(index);
        calcDocument();
    }

    
    function createState(){
        return {
            ...state,
            document_settings_id: settings?.id,

            document_account: documentForm.getValues().document_account,
            car: documentForm.getValues().car,

            works: worksForm.getValues().works,
            items: itemsForm.getValues().items,
            payments: paymentsForm.getValues().payments,
            reference: documentForm.getValues().reference,

            itemRowIndex: itemRowIndex,

        }
    }

    
    function createBreadcrumbData(state: any){

        const thisPageLink = 'id' in documentForm.getValues() ?
            `/documents/${(documentForm as  UseFormReturn<DocumentEdit>).getValues("id")}` :
            `/documents/add?documentType=${settings?.id}`;

        return [
            {
                name: "מסמכים",
                link: "/documents",
            },
            {
                name: "הוספת מסמך",
            },
            {
                name: `${settings?.name}`,
                link: thisPageLink,
                state: state
            },
        ];
    }


    //navigate to item browsing
    function browseItem() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/items`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "בחירת פריט" }]
            }
        });
    }


    //navigate to add item
    function addItem() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/items/add`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "הוספת כרטיס פריט" }]
            }
        });
    }


    //navigate to edit item
    function editItem() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);

        navigate(`/items/${itemsForm.getValues().items[itemRowIndex]?.item_id || itemsForm.getValues().items[itemRowIndex]?.id}`, {
            replace: true,
            state: {
                ...currentState,
                breadcrumbData: [...breadcrumbData, { name: "עריכת כרטיס פריט" }]
            }
        });
    }


    function editItemStructure() {

        const currentState = createState();
        const breadcrumbData = createBreadcrumbData(currentState);


        navigate(`/documents/structure/item?documentType=${settings.id}`, {
            replace: true,
            state: {
                breadcrumbData: [...breadcrumbData, { name: "הגדרת מבנה" }, { name: "פריט" }]
            }
        });
    }



    if (method === "add") {
        return (
            <>
                <div className="title">
                    <div>
                        <Typography variant="body1" component="span">
                            פריטים:
                        </Typography>
                        <Tooltip title="בחירת כרטיס פריט מתוך דפדוף" placement="top">
                            <span>
                                <IconButton onClick={browseItem} sx={{ color: theme.colors.main_color }}>
                                    <AutoStoriesIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת כרטיס פריט" placement="top">
                            <span>
                                <IconButton onClick={addItem} disabled={!!itemsForm.getValues().items?.[itemRowIndex]?.id} sx={{ color: theme.colors.main_color }}>
                                    <BookmarkAddIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="עריכת כרטיס פריט" placement="top">
                            <span>
                                <IconButton onClick={editItem} disabled={!itemsForm.getValues().items?.[itemRowIndex]?.id} sx={{ color: theme.colors.main_color }}>
                                    <EditIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת שורה" placement="top">
                            <span>
                                <IconButton onClick={addItemLine} sx={{ color: theme.colors.main_color }}>
                                    <ExpandMoreIcon />
                                </IconButton>
                            </span>
                        </Tooltip>

                    </div>
                    <div>
                        <Tooltip title="הגדרת שדות פריט" placement="top">
                            <IconButton onClick={editItemStructure} sx={{ color: theme.colors.main_color }}>
                                <SettingsIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>

                <table>
                    <tbody>
                        {
                            itemsFieldArray.fields.map((field, rowIndex) => (
                                <tr key={rowIndex+"."+field.name} onClick={() => { setItemRowIndex(rowIndex) }}>
                                    <td className="td-text">{rowIndex + 1}.</td>
                                    {
                                        structure?.sort((a, b) => (a.location || 0) - (b.location || 0)).map((field, fieldIndex) => {
                                            // return (field.type === "פריט" && field.show_form) ? <td key={fieldIndex}><MuiInput field={field} variant='outlined' useForm={itemsForm} prefix={`items.${rowIndex}.`} showRequired autoFocus={isFocused(`items.${rowIndex}.`, field.field_name)} /></td> : null
                                            return (field.type === "פריט" && field.show_form) ? 
                                                <td key={fieldIndex}>
                                                    {
                                                        renderItemField(field, rowIndex)
                                                    }
                                                </td> : null

                                        })
                                    }
                                    <td className="delete-row">
                                        <Tooltip title="הסרת שורה" placement="top">
                                            <span>
                                                <IconButton onClick={()=>{deleteRow(rowIndex)}} sx={{ color: theme.colors.main_color }}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </td>

                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </>            
        )
    }

    else if (method === "edit") {
        return (
            <>
                <div className="title">
                    <div>
                        <Typography variant="body1" component="span" sx={{
                            color: !isDocumentClosed ? "text.primary" : "action.disabled",
                        }}>
                            פריטים:
                        </Typography>
                        <Tooltip title="בחירת כרטיס פריט מתוך דפדוף" placement="top">
                            <span>
                                <IconButton onClick={browseItem} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                    <AutoStoriesIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת כרטיס פריט" placement="top">
                            <span>
                                <IconButton onClick={addItem} disabled={!!itemsForm.getValues().items?.[itemRowIndex]?.id || isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <BookmarkAddIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="עריכת כרטיס פריט" placement="top">
                            <span>
                                <IconButton onClick={editItem} disabled={!itemsForm.getValues().items?.[itemRowIndex]?.id || isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <EditIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="הוספת שורה" placement="top">
                            <span>
                                <IconButton onClick={addItemLine} disabled={isDocumentClosed} sx={{ color: theme.colors.main_color }}>
                                    <ExpandMoreIcon />
                                </IconButton>
                            </span>
                        </Tooltip>

                    </div>
                    <div>
                        <Tooltip title="הגדרת שדות פריט" placement="top">
                            <IconButton onClick={editItemStructure} sx={{ color: isDocumentClosed? "rgba(0,0,0,0.3)" : theme.colors.main_color }}>
                                <SettingsIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>

                <table className={isDocumentClosed? "disabled" : ""}>
                    <tbody>
                        {
                            itemsFieldArray.fields.map((field, rowIndex) => (
                                <tr key={rowIndex+"."+field.name} onClick={() => { setItemRowIndex(rowIndex) }}>
                                    <td className="row-number">{rowIndex + 1}.</td>
                                    {
                                        structure?.sort((a, b) => (a.location || 0) - (b.location || 0)).map((field, fieldIndex) => {
                                            // return (field.type === "פריט" && field.show_form) ? <td key={fieldIndex}><MuiInput field={field} variant='outlined' useForm={itemsForm} prefix={`items.${rowIndex}.`} showRequired autoFocus={isFocused(`items.${rowIndex}.`, field.field_name)} disabled={isDocumentClosed} /></td> : null
                                            return (field.type === "פריט" && field.show_form) ? 
                                                <td key={fieldIndex}>
                                                    {
                                                        renderItemField(field, rowIndex)
                                                    }
                                                </td> : null    
                                        })
                                    }
                                    <td className="delete-row">
                                        <Tooltip title="הסרת שורה" placement="top">
                                            <span>
                                                <IconButton onClick={()=>{deleteRow(rowIndex)}} sx={{ color: theme.colors.main_color }} disabled={isDocumentClosed}>
                                                    <ClearIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </td>

                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </>
        )
    }

}

export default DocumentItems